import { BankPlusIcon } from './BankPlusIcon';

/**
 * author: Rosemary Stanley
 * id DCB74822-6C93-473B-88B4-1818CFDE2B69
 * name bank-plus
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bank-plus.svg
 * tags
 * - Banking 
 */
export const BankAddIcon = BankPlusIcon;
export default BankAddIcon